import { SortingState } from "@tanstack/react-table";
import { DynamicMenuItem } from "Common/Components/DynamicActionMenu/DynamicActionMenu";
import { Card, Col, Row } from "react-bootstrap";
import { Fragment, useCallback, useEffect, useMemo, useState } from "react";
import { Modal } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
// import UploadInvoice from "./UploadInvoice/UploadInvoice";
import FormattedDate from "Common/Components/NameWithDate.tsx/FormattedDate";
import MasterTableContainer from "Common/Tables/MasterFiltersTable/MasterTableContainer";
import SearchBox from "Common/Components/SearchBox/SearchBox";
import ColumnVisibilityDropdown from "Common/Components/ColumnFilteringPopUp/ColumnFilteringPopUp";
import ExportButton from "Common/Components/Buttons/ExportButton";
import LoadingSpinner from "components/LoadingSpinner";
import { Visibility } from "@mui/icons-material";
import NameWithDate from "Common/Components/NameWithDate.tsx/NameWithDate";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import { exportPaymentManagementCSV, fetchPaymentManagementByType } from "slices/paymentmanagement/thunk";
import { Dialog, DialogContent, DialogTitle, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import StatusChip from "pages/Enquiry/Components/StatusChip";
import { API_ENDPOINT } from "helpers/Endpoints/endpoints";
import { formatIndianAmount } from "helpers/formatIndianAmount";
import Chip from "components/Chips/Chip";
import Tooltip from "@mui/material/Tooltip";
import { SALES_ORDER_CATEGORY, SALES_ORDER_TYPE } from "Constants/StatusConstant";
import FollowupModel from "./FollowUp/FollowupModel";
import LoaderErrorWrapper from "Common/Components/LoaderErrorWrapper/LoaderErrorWrapper";
import { app_modules } from "helpers/apps_modules_list";
import usePermission from "hooks/usePermission";
import { TableKeys } from "Constants/TableKeys/TableKeys";
import usePreservedTableState from "CustomHooks/usePreservedTableState";
import DOMPurify from "dompurify";
import FollowUpPopUp from "pages/PaymentManagement/FollowUpModalForPaymentManagement/FollowUpPopUp";
import { hideTagsSearchListingSection } from "pages/TagsSearchPage/utils/tagsSearchEmpty";

type PBGProps = {
  activeTab?: string;
  noWrapper?: boolean;
  forceShowOnTagsSearch?: boolean;
};

const PBGListing: React.FC<PBGProps> = ({
  activeTab,
  noWrapper = false,
  forceShowOnTagsSearch = false,
}) => {
  document.title = "Payment Management";

  const tableState = usePreservedTableState({
    key: TableKeys.PAYMENT_MANAGEMENT.PRODUCT.PBG,
    defaults: {
      pageIndex: 0,
      pageSize: 10,
      search: "",
      searchInput: "",
      sorting: [],
      columnFilters: [],
      filterValue: [],
    },
  });

  const {
    pageIndex,
    pageSize,
    search,
    searchInput,
    sorting,
    columnFilters,
    filterValue,
    setPageIndex,
    setPageSize,
    setSearch,
    setSearchInput,
    setSorting,
    setColumnFilters,
    setFilterValue,
    resetState,
  } = tableState;


  // const [pageIndex, setPageIndex] = useState(0);
  // const [pageSize, setPageSize] = useState(10);
  const [data, setData] = useState<any[]>([]);
  const [totalRecords, setTotalRecords] = useState(0);
  // const [columnFilters, setColumnFilters] = useState<any>([]);
  // const [sorting, setSorting] = useState<SortingState>([]);
  // const [search, setSearch] = useState("");
  // const [searchInput, setSearchInput] = useState("");
  // const [filterValue, setFilterValue] = useState<any[]>([]);
  const [tableInstance, setTableInstance] = useState<any>();
  const navigate = useNavigate();
  const { tags: tagsParam } = useParams<{ tags?: string }>();
  const tagFromUrl = useMemo(() => {
    if (!tagsParam) return "";
    try {
      return decodeURIComponent(tagsParam).trim();
    } catch {
      return tagsParam.trim();
    }
  }, [tagsParam]);
  const effectiveSearch = tagFromUrl || search;
  const dispatch = useDispatch<any>();
  const [showModal, setShowModal] = useState<boolean>(false);
  const [showFollowUpModal, setShowFollowUpModal] = useState<boolean>(false);
  const [selectedFollowUpItem, setSelectedFollowUpItem] = useState<any>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const { canView, canCreate, canUpdate } = usePermission(
    app_modules?.payment_management?.app_name,
    app_modules?.payment_management?.modules?.product
  );

  const handleFetchPaymentManagement = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const sort = sorting[0]?.id;
      const order = sorting[0]?.desc ? "desc" : "asc";

      const response = await dispatch(
        fetchPaymentManagementByType({
          activeTab: activeTab || "PBG",
          page: pageIndex + 1,
          pageSize,
          search: effectiveSearch,
          ...(tagFromUrl ? { type: "tag" } : {}),
          sort,
          order,
          filters: filterValue,
        })
      ).unwrap();
      setData(response.data);
      setTotalRecords(response.rowCount ?? 0);
    } catch (error: any) {
      console.error("Error fetching payment management data:", error);
      setError(error.message || "An error occurred");
      setData([]);
      setTotalRecords(0);
    } finally {
      setLoading(false);
    }
  }, [dispatch, activeTab, pageIndex, pageSize, sorting, filterValue, effectiveSearch]);

  useEffect(() => {
    handleFetchPaymentManagement();
  }, [handleFetchPaymentManagement]);

  // Debouncing
  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      setSearch(searchInput);
    }, 500);

    return () => clearTimeout(delayDebounce);
  }, [searchInput]);

  useEffect(() => {
    if (!tagFromUrl) return;
    setSearchInput(tagFromUrl);
    setSearch(tagFromUrl);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tagFromUrl]);

  const columns = useMemo(() => {
    return [
      // {
      //   header: "Sr.No",
      //   accessorKey: "sr_no",
      //   enableColumnFilter: false,
      //   enableSorting: false,
      //   cell: ({ row }: { row: any }) => row.original.sr_no,
      // },
      {
        header: "SO No.",
        accessorKey: "sales_order_number",
        enableSorting: false,
        enableColumnFilter:   false,
        filterFetchUrl: API_ENDPOINT?.PAYMENT_MANAGEMENT?.PRODUCT?.FILTER_DROPDOWN(
          "sales_order_number",
          "pbg"
        ),
        filterType: "dropdown" as const,
        cell: ({ row }: { row: any }) => row.original.sales_order_number ?? "-",
      },
      {
        header: "PBG Number",
        accessorKey: "pbg_number",
        enableColumnFilter: false,
        enableSorting: false,
        cell: ({ row }: { row: any }) => row.original.pbg_number ?? "-",
      },
      {
        header: "Customer Name",
        accessorKey: "customer_name",
        enableColumnFilter: false,
        enableSorting: false,
        filterFetchUrl: API_ENDPOINT?.PAYMENT_MANAGEMENT?.PRODUCT?.FILTER_DROPDOWN(
          "customer_name",
          "pbg"
        ),
        filterType: "dropdown" as const,
        cell: ({ row }: { row: any }) => row.original.customer_name ?? "-",
      },
      // {
      //   header: "Total Amount",
      //   accessorKey: "total_amount",
      //   enableColumnFilter: false,
      //   enableSorting: true,
      //   cell: ({ row }: { row: any }) => row.original.total_amount != null ? `${row.original.currency_symbol}${row.original.total_amount.toLocaleString()}` : "-",
      // },
      {
        header: "Total PBG Amount",
        accessorKey: "pbg_amount",
        enableColumnFilter: false,
        enableSorting: false,
        cell: ({ row }: { row: any }) => {
          const symbol = row.original.currency_symbol || "₹";
          return `${symbol} ${formatIndianAmount(row.original.pbg_amount)}`;
        },
      },

      {
        header: "PBG Date",
        accessorKey: "pbg_date",
        enableColumnFilter: false,
        enableSorting:  false,
        filterType: "date" as const,
        cell: ({ row }: { row: any }) => (
          <FormattedDate date={row.original.pbg_date} />
        ),
      },
      {
        header: "Bank Name",
        accessorKey: "bank_name",
        enableColumnFilter: false,
        enableSorting: false,
        filterFetchUrl: API_ENDPOINT?.PAYMENT_MANAGEMENT?.PRODUCT?.FILTER_DROPDOWN(
          "bank_name",
          "pbg"
        ),
        filterType: "dropdown" as const,
        cell: ({ row }: { row: any }) => row.original.bank_name ?? "-",
      },

      {
        header: "PBG Status",
        accessorKey: "pbg_status",
        enableSorting: false,
        enableColumnFilter: false,
        filterType: "dropdown" as const,
        filterFetchUrl: API_ENDPOINT?.PAYMENT_MANAGEMENT?.PRODUCT?.FILTER_DROPDOWN(
          "pbg_status",
          "pbg"
        ),
        cell: ({ row }: { row: any }) => {
          const status = row.original.pbg_status;
          return <StatusChip status={status} />;
        },
      },
      {
        header: "Validity",
        accessorKey: "validity",
        enableColumnFilter: false,
        enableSorting: false,
        filterType: "date" as const,
        cell: ({ row }: { row: any }) => (
          <FormattedDate date={row.original.validity} />
        ),
      },
      {
        header: "Last Follow Up Date",
        accessorKey: "follow_up_date",
        enableColumnFilter: false,
        enableSorting: false,
        filterType: "date" as const,
        cell: ({ row }: { row: any }) => (
          <FormattedDate date={row.original.follow_up_date} />
        ),
      },
      {
        header: "Follow Up Remark",
        accessorKey: "follow_up_remark",
        enableColumnFilter: false,
        enableSorting: false,
        cell: ({ row }: { row: any }) => {
          const rawHtml = row.original?.follow_up_remark || "-";

          if (!rawHtml) return <span>-</span>;

          const safeHtml = DOMPurify.sanitize(rawHtml);

          return (
            <Tooltip
              arrow
              placement="top"
              title={
                <div
                  style={{
                    maxWidth: "450px",
                    whiteSpace: "normal",
                    wordBreak: "break-word",
                  }}
                  dangerouslySetInnerHTML={{ __html: safeHtml }}
                />
              }
              componentsProps={{
                tooltip: {
                  sx: {
                    maxWidth: 500,
                    p: 1.5,
                  },
                },
              }}
            >
              <div
                style={{
                  minWidth: "200px",
                  maxWidth: "400px",
                  display: "-webkit-box",
                  WebkitLineClamp: 4,
                  WebkitBoxOrient: "vertical",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  wordBreak: "break-word",
                  lineHeight: "1.5",
                  maxHeight: "6em", // 4 lines * 1.5 line-height
                  cursor: "pointer",
                }}
                dangerouslySetInnerHTML={{ __html: safeHtml }}
              />
            </Tooltip>
          );
        },
      },
      {
        header: "Next Follow Up Date",
        accessorKey: "next_follow_up_date",
        enableColumnFilter: false,
        enableSorting: false,
        filterType: "date" as const,
        cell: ({ row }: { row: any }) => (
          <FormattedDate date={row.original.next_follow_up_date} />
        ),
      },
      // {
      //   header: "Assigned To",
      //   accessorKey: "assigned_members",
      //   enableColumnFilter: false,
      //   enableSorting: false,
      //   cell: ({ row }: { row: any }) => {
      //     const members = row.original?.assigned_members || [];

      //     if (!members.length) return "-";

      //     const names = members.map(
      //       (m: any) =>
      //         `${m.first_name || ""} ${m.last_name || ""}`.trim() || m.username
      //     );

      //     const visible = names.slice(0, 4);
      //     const remaining = names.length - visible.length;

      //     return (
      //       <Tooltip
      //         arrow
      //         placement="top"
      //         title={names.join("\n")}
      //         componentsProps={{
      //           tooltip: {
      //             sx: {
      //               whiteSpace: "pre-line",
      //               maxWidth: 250,
      //               fontSize: "13px",
      //             },
      //           },
      //         }}
      //       >
      //         <div style={{ cursor: "pointer", lineHeight: 1.4 }}>
      //           {visible.map((name: string, index: number) => (
      //             <div key={index}>{name}</div>
      //           ))}

      //           {remaining > 0 && (
      //             <div style={{ fontSize: "12px", color: "#6c757d" }}>
      //               +{remaining} more
      //             </div>
      //           )}
      //         </div>
      //       </Tooltip>
      //     );
      //   },
      // },
      {
        header: "Created By/Date",
        accessorKey: "created_at",
        enableColumnFilter: false,
        enableSorting: false,
        filterType: "date" as const,
        cell: ({ row }: { row: any }) => {
          const user = row.original.created_by_user;
          return (
            <NameWithDate name={user?.username ?? "-"} date={row.original.created_at} />
          );
        },
      },
      {
        header: "Tags",
        accessorKey: "tags",
        enableColumnFilter: false,
        enableSorting: false,
        cell: ({ row }: { row: any }) => {
          const tags: string[] = row.original.tags || [];
          if (!tags.length) return "-";

          const maxVisible = 3;
          const visible = tags.slice(0, maxVisible);
          const remaining = tags.length - visible.length;
          const tooltipText = tags.join(", ");

          return (
            <Tooltip
              arrow
              placement="top"
              title={tooltipText}
              componentsProps={{
                tooltip: {
                  sx: {
                    maxWidth: 300,
                    fontSize: "13px",
                    whiteSpace: "normal",
                  },
                },
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: "4px",
                  minWidth: "150px",
                  cursor: "pointer",
                }}
              >
                {visible.map((tag: string) => (
                  <Chip key={tag}>{tag}</Chip>
                ))}
                {remaining > 0 && <Chip>+{remaining} more</Chip>}
              </div>
            </Tooltip>
          );
        },
      },  
      {
        header: "Updated By/Date",
        accessorKey: "updated_at",
        enableColumnFilter: false,
        enableSorting: false,
        filterType: "date" as const,
        cell: ({ row }: { row: any }) => {
          const user = row.original.updated_by_user;
          return (
            <NameWithDate name={user?.username ?? "-"} date={row.original.updated_at} />
          );
        },
      },
      {
        header: "Action",
        enableColumnFilter: false,
        enableSorting: false,
        cell: ({ row }: { row: any }) => {
          const data = row.original;
          const grn_details_id = row.original.grn_details_id;
          const menuItems = [
            {
              icon: <PersonAddIcon fontSize="small" color="primary" />,
              label: "Follow-Up",
              permission: canUpdate,
              onClick: (item: any) => {
                setSelectedFollowUpItem(data);
                setShowFollowUpModal(true);
              },
              color: "primary",
            },
          ];
          return <DynamicMenuItem row={data} menuItems={menuItems} />;
        },
      },
    ].filter((column) => column.header !== "Action" || canUpdate);
  }, [navigate, canUpdate]);

  if (
    hideTagsSearchListingSection(
      noWrapper,
      loading,
      totalRecords,
      (data || []).length,
      error,
    ) &&
    !forceShowOnTagsSearch
  ) {
    return null;
  }

  return (
    <Fragment>
      <>
        <Card.Body>
          <LoaderErrorWrapper loading={loading} error={error}>
            <MasterTableContainer
              columns={columns}
              data={data || []}
              totalRecords={totalRecords}
              pageIndex={pageIndex}
              pageSize={pageSize}
              onPageChange={setPageIndex}
              onPageSizeChange={setPageSize}
              columnFilters={columnFilters}
              setColumnFilters={setColumnFilters}
              colValue={setFilterValue}
              sorting={sorting}
              onSortingChange={setSorting}
              isBordered={false}
              isPagination={true}
              manualSorting={true}
              onTableReady={setTableInstance}
            />
          </LoaderErrorWrapper>
        </Card.Body>
      </>
      {/* <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        size="xl"
        centered
      >
        <UploadInvoice setShowModal={setShowModal} />
      </Modal> */}

      <Dialog
        open={showFollowUpModal}
        onClose={() => setShowFollowUpModal(false)}
        maxWidth={false}
        sx={{
          "& .MuiDialog-paper": {
            width: "95vw",
            maxWidth: "95vw",
            height: "100vh",
            borderRadius: "12px",
          },
        }}
        scroll="paper"
      >
        <DialogTitle sx={{ m: 0, p: 2, fontWeight: "bold", fontSize: "0.95rem", display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          PBG Follow-up and Activities
          <IconButton
            aria-label="close"
            onClick={() => setShowFollowUpModal(false)}
            sx={{
              color: (theme) => theme.palette.grey[500],
              fontSize: "0.95rem",
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers sx={{ p: 2, backgroundColor: "#f8f9fa" }}>
          {selectedFollowUpItem && (
            <FollowUpPopUp
              open={showFollowUpModal}
              onClose={() => {
                setShowFollowUpModal(false);
                handleFetchPaymentManagement();
              }}
              title="PBG Follow-up and Activities"
            >
              {selectedFollowUpItem && (
                <FollowupModel
                  data={{
                    ...selectedFollowUpItem,
                    sales_order_product_id: selectedFollowUpItem.sales_order_product_id || selectedFollowUpItem.id,
                  }}
                  activeType={SALES_ORDER_TYPE?.PRODUCT}
                  category={SALES_ORDER_CATEGORY?.PBG}
                  onClose={() => {
                    setShowFollowUpModal(false)
                    handleFetchPaymentManagement()
                  }
                  }
                  showAssignedMembers={false}
                />
              )}
            </FollowUpPopUp>
          )}
        </DialogContent>
      </Dialog>
    </Fragment>
  );
};

export default PBGListing;
